import { FunctionalComponent, h } from "@stencil/core";

type Payment = { statusCode: string; statusText: string };
type ProductAvailability = { statusCode: string; statusText: string };

export const DuePaymentStatus: FunctionalComponent<Payment> = (
  props: Payment
): any => {
  const duePaymentStatus = {
    overdue: "red",
    due: "green",
  };
  const status = duePaymentStatus[props.statusCode.toLowerCase()];

  return (
    <span>
      <span class={`status-indicator status-indicator-${status}`} />
      <span class={`status-${status}`}>{props.statusText}</span>
    </span>
  );
};

export const InvoiceStatus: FunctionalComponent<Payment> = (
  props: Payment
): any => {
  const status = props.statusCode.toLowerCase();

  return (
    <span>
      <span class={`status-indicator status-indicator-${status}`} />
      <span class={`status-${status}`}>{props.statusText}</span>
    </span>
  );
};
export const ProductAvailabilityStatus: FunctionalComponent<
  ProductAvailability
> = (props: ProductAvailability): any => {
  const productAvailabilityStatus = {
    inStock: "green",
    lowStock: "yellow",
    outOfStock: "red",
    noInfo: "grey",
  };
  const status = productAvailabilityStatus[props.statusCode];

  return (
    <span>
      <span class={`status-indicator status-indicator-${status}`} />
      <span class={`status-${status}`}>{props.statusText}</span>
    </span>
  );
};
